var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{class:['visual', {'visual_theme_floor': _vm.$route.name === 'floor'}]},[_c('router-view',{key:_vm.$route.name,attrs:{"filterData":_vm.filterData},on:{"saveParametricLink":_vm.saveLink,"saveFilter":_vm.saveFilter}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }